import React from "react";

import { createBrowserHistory } from 'history'
const history = createBrowserHistory();

export const AAVText = () => {
  return (
    <div className="aav-text-svg">
      <div
        className="clickable"
        onClick={() => { history.go(0) }}
      > 
        <svg
          className="header__site-brand-svg"
          height="60"
          width="300"
          viewBox="0 0 535 52"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd">
            <g fill="#2158CB">
              <g>
                <path
                  d="M86.33 24.22A79.67 79.67 0 0 0 74 12.16a64.06 64.06 0 0 0-13.49-8.32A41.16 41.16 0 0 0 43.69 0a41.16 41.16 0 0 0-16.82 3.84 64.06 64.06 0 0 0-13.47 8.32A79.67 79.67 0 0 0 1.05 24.22L0 25.55l1.05 1.33A79.46 79.46 0 0 0 13.4 39a70 70 0 0 0 8 5.5l8.6-8.62c-5.334-7.05-4.464-16.993 2.014-23.009 6.477-6.015 16.458-6.149 23.094-.308 6.637 5.84 7.772 15.757 2.628 22.946-5.143 7.19-14.896 9.316-22.566 4.921l-7.28 7.27a40.42 40.42 0 0 0 15.8 3.41 41 41 0 0 0 16.82-3.85A64.42 64.42 0 0 0 74 39a79.46 79.46 0 0 0 12.33-12.12l1-1.33-1-1.33z"
                  id="logo__eye--outer"
                ></path>
                <path
                  d="M43.69 15.44a9.92 9.92 0 0 0-2.85.42 5.19 5.19 0 0 1-7 7.31 10.41 10.41 0 0 0-.29 2.38c-.006 5.588 4.519 10.123 10.107 10.13 5.587.007 10.124-4.516 10.133-10.103.01-5.588-4.512-10.126-10.1-10.137z"
                  id="logo__eye--inner"
                ></path>
              </g>
            </g>
          </g>
          <g fill="none" fillRule="evenodd">
            <g fill="#2158CB">
              <g>
                <path
                  d="M102.47 39.41l13.26-28.52a.87.87 0 0 1 .72-.47h.42a.86.86 0 0 1 .72.47l13.27 28.52a.75.75 0 0 1-.72 1.1h-4.71c-.76 0-1.1-.26-1.48-1.06l-1.53-3.35H110.9l-1.53 3.39a1.58 1.58 0 0 1-1.52 1h-4.66a.74.74 0 0 1-.72-1.08zm17.41-9.07l-3.22-7-3.18 7h6.4z"
                  id="Shape"
                  fillRule="nonzero"
                ></path>
                <path
                  d="M138.14 11.65a.8.8 0 0 1 .81-.8h5a.83.83 0 0 1 .8.8v22.63h10.09a.8.8 0 0 1 .8.81v4.61a.8.8 0 0 1-.8.81H139a.81.81 0 0 1-.81-.81l-.05-28.05zM163.61 11.65a.8.8 0 0 1 .8-.8h5a.83.83 0 0 1 .81.8v22.63h10.08a.81.81 0 0 1 .81.81v4.61a.81.81 0 0 1-.81.81h-15.89a.8.8 0 0 1-.8-.81V11.65z"
                  id="Path"
                ></path>
                <path
                  d="M198.43 39.41l13.27-28.52a.86.86 0 0 1 .72-.47h.42a.87.87 0 0 1 .72.47l13.26 28.52a.74.74 0 0 1-.72 1.1h-4.7c-.76 0-1.1-.26-1.48-1.06l-1.53-3.35h-11.52l-1.53 3.39a1.58 1.58 0 0 1-1.52 1h-4.66a.75.75 0 0 1-.73-1.08zm17.42-9.07l-3.22-7-3.18 7h6.4zM234.11 11.65a.8.8 0 0 1 .81-.8h9.87c5 0 9.11 3.43 9.11 7.88 0 3.26-2.92 5.63-4.92 6.69 2.25.94 5.68 3 5.68 6.91 0 4.75-4.19 8.18-9.23 8.18h-10.51a.81.81 0 0 1-.81-.81V11.65zM244 22.88a3 3 0 0 0 3-3.05 2.87 2.87 0 0 0-3-2.83h-3.31v5.93l3.31-.05zm.55 11.57a3.08 3.08 0 0 0 3-3.09c0-1.7-1.82-3-3.48-3h-3.43v6.06l3.91.03zM276.91 10.42c8.428-.022 15.278 6.792 15.3 15.22.022 8.428-6.792 15.278-15.22 15.3-8.428.022-15.278-6.792-15.3-15.22a15.23 15.23 0 0 1 15.22-15.3zm0 23.73a8.48 8.48 0 1 0 .08-16.96 8.48 8.48 0 0 0-.08 16.96z"
                  id="Shape"
                  fillRule="nonzero"
                ></path>
                <path
                  d="M300.68 11.65a.83.83 0 0 1 .8-.8h5.21a.8.8 0 0 1 .81.8v17.16a5.26 5.26 0 1 0 10.51 0V11.65a.8.8 0 0 1 .8-.8H324a.83.83 0 0 1 .81.8v17.5c-.188 6.534-5.539 11.732-12.075 11.732s-11.887-5.198-12.075-11.732l.02-17.5zM339.28 17.08h-6.06a.81.81 0 0 1-.81-.81v-4.62a.8.8 0 0 1 .81-.8H352a.8.8 0 0 1 .81.8v4.62a.81.81 0 0 1-.81.81h-6V39.7a.83.83 0 0 1-.8.81h-5.09a.83.83 0 0 1-.8-.81l-.03-22.62zM370.25 12a.75.75 0 0 1 .72-1.1h5.64a.85.85 0 0 1 .72.46l7 15.47h.25l7-15.47a.83.83 0 0 1 .72-.46h5.64a.75.75 0 0 1 .72 1.1l-13.3 28.52a.83.83 0 0 1-.73.46h-.42a.81.81 0 0 1-.72-.46L370.25 12zM405.93 11.65a.83.83 0 0 1 .8-.8h5.09a.83.83 0 0 1 .8.8V39.7a.83.83 0 0 1-.8.81h-5.09a.83.83 0 0 1-.8-.81V11.65zM422 36.48l2-3.48a1.1 1.1 0 0 1 1.44-.26c.17.09 3.22 2.33 6 2.33a2.66 2.66 0 0 0 2.92-2.54c0-1.78-1.48-3.13-4.36-4.28-3.65-1.44-8.23-4.28-8.23-9.36 0-4.2 3.27-8.44 9.79-8.44a15.77 15.77 0 0 1 9.07 3.18c.404.33.514.903.26 1.36l-2.17 3.26c-.29.47-1.06.85-1.44.55-.38-.3-3.47-2.54-6.06-2.54a2.45 2.45 0 0 0-2.66 2.16c0 1.57 1.27 2.75 4.61 4.11 3.34 1.36 8.56 3.9 8.56 9.66 0 4.37-3.77 8.77-10 8.77-5.51 0-8.56-2.29-9.53-3.26-.39-.45-.51-.62-.2-1.22zM450.75 11.65a.84.84 0 0 1 .81-.8h5.08a.83.83 0 0 1 .81.8V39.7a.83.83 0 0 1-.81.81h-5.08a.84.84 0 0 1-.81-.81V11.65z"
                  id="Path"
                ></path>
                <path
                  d="M481.6 10.42a15.26 15.26 0 1 1-15.21 15.3 15.23 15.23 0 0 1 15.21-15.3zm0 23.73a8.48 8.48 0 1 0 .1-16.96 8.48 8.48 0 0 0-.1 16.96z"
                  id="Shape"
                  fillRule="nonzero"
                ></path>
                <path
                  d="M505.75 11.19a.8.8 0 0 1 .81-.77h1.05l16.91 16.28v-15a.8.8 0 0 1 .81-.8h5.08a.83.83 0 0 1 .81.8v28.47a.8.8 0 0 1-.81.76h-.67a1.15 1.15 0 0 1-.55-.21l-16.7-16.82v15.8a.81.81 0 0 1-.81.81h-5a.83.83 0 0 1-.81-.81l-.12-28.51z"
                  id="Path"
                ></path>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div >
  );
};

export const EyeIcon = () => {
  return (
    <div className="eye-icon-svg">
      <div
        className="clickable"
        onClick={() => window.open("https://www.allaboutvision.com/", "_blank")}
      >
        <svg
          className="header__site-brand-svg"
          height="75"
          width="75"
          viewBox="0 0 100 52"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd">
            <g fill="#2158CB">
              <g>
                <path
                  d="M86.33 24.22A79.67 79.67 0 0 0 74 12.16a64.06 64.06 0 0 0-13.49-8.32A41.16 41.16 0 0 0 43.69 0a41.16 41.16 0 0 0-16.82 3.84 64.06 64.06 0 0 0-13.47 8.32A79.67 79.67 0 0 0 1.05 24.22L0 25.55l1.05 1.33A79.46 79.46 0 0 0 13.4 39a70 70 0 0 0 8 5.5l8.6-8.62c-5.334-7.05-4.464-16.993 2.014-23.009 6.477-6.015 16.458-6.149 23.094-.308 6.637 5.84 7.772 15.757 2.628 22.946-5.143 7.19-14.896 9.316-22.566 4.921l-7.28 7.27a40.42 40.42 0 0 0 15.8 3.41 41 41 0 0 0 16.82-3.85A64.42 64.42 0 0 0 74 39a79.46 79.46 0 0 0 12.33-12.12l1-1.33-1-1.33z"
                  id="logo__eye--outer"
                ></path>
                <path
                  d="M43.69 15.44a9.92 9.92 0 0 0-2.85.42 5.19 5.19 0 0 1-7 7.31 10.41 10.41 0 0 0-.29 2.38c-.006 5.588 4.519 10.123 10.107 10.13 5.587.007 10.124-4.516 10.133-10.103.01-5.588-4.512-10.126-10.1-10.137z"
                  id="logo__eye--inner"
                ></path>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
  );
};
